<template>
  <section class="vertical-set-weight-to-apply-to-added-hands">
    <vertical-set-weight-to-apply-to-added-hands-basic
      v-if="settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderBasic'"
      ref="basicSlider"
      v-bind:weightToApplyToAddedHands="weightToApplyToAddedHands"
      v-bind:disabled="disabled"
      v-bind:shortDeck="shortDeck"
      v-on:setWeightToApplyToAddedHands="$emit('setWeightToApplyToAddedHands', $event)"
    />
    <vertical-set-weight-to-apply-to-added-hands-with-settings
      v-if="settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderWithSettings'"
      ref="sliderWithSettings"
      v-bind:disabled="disabled"
      v-on:setWeightToApplyToAddedHands="$emit('setWeightToApplyToAddedHands', $event)"
    />
  </section>
</template>

<script>
import VerticalSetWeightToApplyToAddedHandsBasic from '@/components/hand-range/hand-weight/vertical-set-weight-to-apply-to-added-hands/vertical-set-weight-to-apply-to-added-hands-basic';
import VerticalSetWeightToApplyToAddedHandsWithSettings from '@/components/hand-range/hand-weight/vertical-set-weight-to-apply-to-added-hands/vertical-set-weight-to-apply-to-added-hands-with-settings';

export default {
  name: 'vertical-set-weight-to-apply-to-added-hands',
  components: {
    'vertical-set-weight-to-apply-to-added-hands-basic': VerticalSetWeightToApplyToAddedHandsBasic,
    'vertical-set-weight-to-apply-to-added-hands-with-settings': VerticalSetWeightToApplyToAddedHandsWithSettings,
  },
  props: ['weightToApplyToAddedHands', 'disabled', 'shortDeck'],
  computed: {
    settingHandWeightsSetting: function () {
      return this.$store.state.account.user.settings.general.visual.settingHandWeights;
    },
  },
  methods: {
    refreshVueSlider: function () {
      if (this.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderBasic') {
        this.$refs.basicSlider.refreshVueSlider();
      } else if (this.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderWithSettings') {
        this.$refs.sliderWithSettings.refreshVueSlider();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .vertical-set-weight-to-apply-to-added-hands {
    display: inline;
  }
</style>



// WEBPACK FOOTER //
// src/components/hand-range/hand-weight/vertical-set-weight-to-apply-to-added-hands/vertical-set-weight-to-apply-to-added-hands.vue